import {Component, Input, OnInit, ViewChild} from '@angular/core';

import {GtNameValueService} from '@app/services/gt-name-value.service';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {PhoneNumberListComponent} from '@app/shared/phone-number-list/phone-number-list.component';
import {NameValueListType} from '@app/services/gt-configuration.service';

@Component({
  selector: 'gt-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.scss']
})
export class BlacklistComponent implements OnInit {
  @Input() listType: NameValueListType;
  @Input() oname: string;
  @Input() login: string;
  @Input() canEdit = true;
  @ViewChild(PhoneNumberListComponent, {static: true}) phoneNumberList: PhoneNumberListComponent;
  blockCLIR: boolean;

  constructor(private nameValueService: GtNameValueService, private notificationService: GtNotificationService) {}

  ngOnInit() {
    this.nameValueService.getEndUserNameValue('BlockCLIR', this.oname, this.login).subscribe(n => {
      this.blockCLIR = Boolean(Number(n));
    }, this.error);
  }

  changeBlockCLIR() {
    this.nameValueService.setEndUserNameValue('BlockCLIR', Number(this.blockCLIR) + '', this.oname, this.login).subscribe({
      error: this.error
    });
  }

  error = error => {
    this.notificationService.errorNotification.next(error);
  };
}
